import { render, staticRenderFns } from "./zuowenlist.vue?vue&type=template&id=2a17489d&scoped=true&"
import script from "./zuowenlist.vue?vue&type=script&lang=js&"
export * from "./zuowenlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a17489d",
  null
  
)

export default component.exports